import script from "./TradePair.vue?vue&type=script&setup=true&lang=ts"
export * from "./TradePair.vue?vue&type=script&setup=true&lang=ts"

import "./TradePair.vue?vue&type=style&index=0&id=534dea40&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-534dea40"]])

export default __exports__